<div style="text-align: center;background-color: blue;color: white;padding: 10px;display: flex;justify-content: space-between;align-items: center;margin: -20px -20px 20px -20px;">
    <span>{{data.title}}</span>
    <button (click)="onClose()" style="background: none;border: none;color: white;font-size: 20px;cursor: pointer;">
        <i class="fas fa-times"></i>
    </button>
</div>
<table>
    <tr>
        <th style="padding-left: 10px !important;">Lead Source Name : </th>
        <th>
            <input type="text" [(ngModel)]="data.model.sourceName" name="sourceName" />
        </th>
    </tr>
    <tr>
        <th style="padding-left: 10px !important;">Source Type : </th>
        <th>
            <select [(ngModel)]="data.model.sourceType" name="sourceType">
                <option value="0">Select</option>
                <option value="API">API</option>
                <option value="Excel File">Excel File</option>
                <option value="Manual">Manual</option>
            </select>
        </th>
    </tr>
    <tr>
        <th style="padding-left: 10px !important;">Source URL : </th>
        <th>
            <input type="text" [(ngModel)]="data.model.sourceURL" name="sourceURL" />
        </th>
    </tr>
    <tr>
        <th style="padding-left: 10px !important;">Authentication Code : </th>
        <th>
            <input type="text" [(ngModel)]="data.model.sourceIdentifier" name="sourceIdentifier" />
        </th>
    </tr>
    <tr>
        <th style="padding-left: 10px !important;">Status : </th>
        <th>
            <select [(ngModel)]="data.model.status" name="status">
                <option value="0" disabled>Select</option>
                <option value="1">Active</option>
                <option value="0">In active</option>
            </select>
        </th>
    </tr>
</table>
<br />
<button class="btn btn-sm btn-primary" (click)="onSave();" style="float: inline-end;">
    <i class="fas fa-plus"></i> Save
</button>